import React from 'react';
import {
  Navigate,
} from 'react-router';
import PAGES from 'common/pages';
import useUser from 'hooks/useUser';

const StaffOrSuperuserGuard = ({ children }) => {
  const [{ data, isLoading }] = useUser();
  if (isLoading) {
    return <div>Loading</div>;
  }
  return data?.is_staff || data?.is_superuser ? children : <Navigate to={PAGES.FORBIDDEN} replace />;
};

export default StaffOrSuperuserGuard;
